import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/bb74bfb/node_modules/@undataforum/gatsby-theme-base/src/components/mdx-page.js";
import MdxLayout from '../../src/components/mdx-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = MdxLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p>{`National Statistical Systems are called to leverage all sources of data at their
disposal and mobilize partners and experts from all sectors of society to
implement solutions for the production of timely and disaggregated statistics
urgently needed to understand and respond to the global COVID-19 crisis.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      